import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { BRITISH_AIRWAYS } from '../data/airlinesData';

export default function BritishAirwaysPage() {
  return <AirlineDetailPage airline={BRITISH_AIRWAYS} />;
}
